import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../contexts/AuthContext";
import { fetchChatAccess } from "../../services/chatApi";

/** Chat access for the signed-in user and company; undefined while loading. */
export function useChatAccess() {
  const { user, isAuthenticated, company } = useAuth();
  const query = useQuery({
    queryKey: ["chat-access", user?._id, company?._id],
    queryFn: fetchChatAccess,
    enabled: isAuthenticated && Boolean(user?._id),
    staleTime: 60 * 1000,
  });
  return { access: query.data, isLoading: query.isLoading };
}
